import Router from 'vue-router';
import Vue from 'vue';
import OTP from '@/components/OTP/OTPLogin';
import MixingRoutes from '@/routes/mixingRoutes';
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);
Vue.use(Router);

const router = new Router({
  routes: [
    MixingRoutes.LandingPageRoutes,
    MixingRoutes.PrivacyPolicyRoutes,
    MixingRoutes.LoginRoutes,
    MixingRoutes.DashboardRoutes,
    {
      path: '/verifyotp',
      component: OTP,
      name: 'OTP'
    },
  ]
});
router.beforeEach((to, from, next) => {
  let localdata = JSON.parse(localStorage.getItem('user-response'));
  if (to.meta.requiredAuth) {
    if (localdata === null) {
      next({
        name : "Login"
      });
    } else if (localdata != null) {
      next();
    }
  } else {
    if (localdata === null) {
      next();
    } else if (localdata != null) {
      next({
        name : "DashboardLayout"
      });
    }
  }
  if (to.meta.adminAuth){
    if(localdata.data.user_role.id === 1){
      next();
    }
    else if (localdata.data.user_role.id != 1) {
      next({
        name : "DashboardLayout"
      });
    }
  }
});
export default router;
